import {BehaviorSubject, ReplaySubject, Subject} from "rxjs";
import {LoadingStatus} from "../common-types/loading-status";
import {AppData} from "./app-entity.model";

export class SessionReset {
    constructor (public retainStore: boolean = false,
                 public retainOrderType: boolean = false) {
    }
}

export class OrchestrationEvents {

    /**
     * Notifies that the app is being redirected to another app.
     */
    public static readonly redirecting$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    /**
     * Notifies that the session has been reset.
     * All models should reset their state accordingly.
     */
    public static readonly sessionReset$: Subject<SessionReset> = new Subject();

    /**
     * Notifies the app's initial load status.
     */
    public static readonly initialLoadStatus$: BehaviorSubject<LoadingStatus> = new BehaviorSubject(LoadingStatus.LOADING);

    /**
     * Notifies the details of the app config on the first time it's loaded.
     */
    public static readonly firstAppLoad$: Subject<AppData> = new ReplaySubject(1);
}



// WEBPACK FOOTER //
// ./src/app/orchestration/orchestration-events.ts